import { css } from "@emotion/react";
import { FC, useEffect, useRef, useState } from "react";
import GText from "./GText";
import { BaseProps } from "./text";

interface Props {
  text?: string;
  link?: string;
  openInNew?: boolean;
  duration?: number;
}

const GTextShine: FC<Props & BaseProps> = (props) => {
  const [textWidth, setTextWidth] = useState(180);
  const textRef = useRef<HTMLAnchorElement>(null);

  useEffect(() => {
    if (textRef.current) {
      setTextWidth(textRef.current.offsetWidth);
    }
  }, []);

  /**
   * animation: shine ${props.duration}s infinite 2s linear;
   *
   * keyframes shine {
      0% {
        background-position: 0;
      }
      60% {
        background-position: ${textWidth}px;
      }
      100% {
        background-position: ${textWidth}px;
      }
    }
   * 
   */

  const textShineStyles = css`
    color: #fff;
    background: linear-gradient(to right, #4d4d4d 0, #fff 10%, #4d4d4d 20%);
    background-position: 0;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    animation: shine ${props.duration}s linear infinite;
    animation-fill-mode: forwards;
    -webkit-text-size-adjust: none;
    font-weight: 600;
    font-size: ${props.fontSize}px;
    text-decoration: none;
    white-space: nowrap;

    @keyframes shine {
      100% {
        background-position: ${textWidth}px;
      }
    }
  `;

  return (
    <GText {...props}>
      <a
        ref={textRef}
        css={textShineStyles}
        href={props.link}
        target={props.openInNew ? "_blank" : "_self"}
      >
        {props.text}
      </a>
    </GText>
  );
};

GTextShine.defaultProps = {
  text: "Subscribe to Grooody",
  duration: 6,
  fontSize: 16,
};

export default GTextShine;

// We need to add the below in framer
/*
addPropertyControls(Button, {
  text: {
    title: "Text",
    type: ControlType.String,
    defaultValue: "Subscribe to Grooody",
  },
    url: {
    title: "URL",
    type: ControlType.Link,
    defaultValue: "",
},
  fontSize: {
    title: "Font Size",
    type: ControlType.Number,
    defaultValue: 16,
  },
  duration: {
    title: "Duration",
    type: ControlType.Number,
    defaultValue: 4,
    description: "Animation duration"
  },
})
*/
